{{#with categoryList}}
    {{#if children}}
        <div>
            {{#each children}}
                <section class="categoryList" id="{{id}}">
                    <div class="categoryList-row">
                        <h2 class="hdg hdg_4">{{name}}</h2>
                        <div class="categoryList-row-bd">
                            <p class="bdcpy">
                                {{removeMarkup content}}
                            </p>
                        </div>
                        <div class="categoryList-row-tiles{{#if customAttributes.[Products per Row]}} categoryList-row-tiles_{{customAttributes.[Products per Row]}}{{/if}}">
                            {{#each products}}
                                {{> categoryListTile}}
                            {{/each}}
                        </div>
                    </div>
                </section>
            {{/each}}
        </div>
    {{else}}
        {{#if products}}
            <section class="categoryList">
                <div class="categoryList-row">
                    <div class="categoryList-row-tiles{{#if customAttributes.[Products per Row]}} categoryList-row-tiles_{{customAttributes.[Products per Row]}}{{/if}}">
                        {{#each products}}
                            {{> categoryListTile}}
                        {{/each}}
                    </div>
                </div>
            </section>
        {{/if}}
    {{/if}}
{{/with}}